<script setup lang="ts">
import {cultureIllustration,isPlantPhotoUuid,isIllustrationSource} from '~/utils/culture-illustration.mjs';
const props = withDefaults(defineProps<{
    uuid?: string | null;
    src?: string | null;
    alt?: string;
    culture?: string | {title?:string};
}>(), {
    uuid: null,
    src: null,
    alt: '',
});

const realSrc=computed(()=>props.src&&!isIllustrationSource(props.src)?props.src:isPlantPhotoUuid(props.uuid)?`/files/uploaded/${props.uuid}.webp`:null);
const isPlaceholder=computed(()=>!realSrc.value);
const illustration=computed(()=>cultureIllustration(props.culture,props.alt));
const imageSrc=computed(()=>realSrc.value||illustration.value.src);
</script>

<template>
    <img
        :src="imageSrc"
        :alt="isPlaceholder ? illustration.alt : alt"
        :title="isPlaceholder ? illustration.alt : undefined"
        :data-culture-illustration="isPlaceholder ? illustration.key : undefined"
        :data-plant-placeholder="isPlaceholder ? 'true' : undefined"
    />
</template>
